import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';
import { API_BASE_URL } from '../providers/constants/api.constants';

@Injectable()
export class ApiEliteInterceptor implements HttpInterceptor {
  // private readonly requestTimeout = 25000; // 25 seconds
  readonly API_URL = `${API_BASE_URL}`;

  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(this.API_URL)) {
      return next.handle(request);
    }
    return next.handle(request).pipe(
      filter((event) => event instanceof HttpResponse),
      // timeout(this.requestTimeout),
      // map((event: HttpResponse<any>) => {
      //   return event.clone({ body: event.body });
      // }),
      catchError((error: HttpErrorResponse) => {
        const errorMessage = error?.error?.message || error?.message;
        return throwError(errorMessage);
      })
    );
  }
}
